<template>
  <div class="popUpWrap">
    <section class="cookiePopup" style="z-index: 3000">
      <div class="topArea flex">
        <svg class="symbolLogo" xmlns="http://www.w3.org/2000/svg" width="103" height="92" viewBox="0 0 103 92" fill="none">
          <path d="M87.5 -108L0 -57.4037V41.3796L31.5972 59.6425V-39.5263L87.5 -71.8598L143.403 -39.5263V23.5263L87.5 55.8598L63.1945 41.8133V77.9535L87.5 92L175 41.4037V-57.4037L87.5 -108Z" fill="#0D2A6F" fill-opacity="0.3" />
        </svg>
        <svg class="quotes" xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
          <path d="M0 6.16611C0 8.25692 0.106312 9.88704 0.318937 11.0565C0.566999 12.2614 1.00997 13.2182 1.64784 13.9269C2.32115 14.6711 3.33112 15.2027 4.67774 15.5216C6.02436 15.8405 7.83167 16 10.0997 16V12.3322C8.46955 12.3322 7.40642 12.0842 6.9103 11.588C6.66224 11.34 6.48505 10.9856 6.37874 10.5249C6.30786 10.0997 6.27243 9.53267 6.27243 8.82392V8.13289H10.0997V0H0V6.16611ZM13.0233 6.16611C13.0233 8.25692 13.1296 9.88704 13.3422 11.0565C13.5903 12.2614 14.0332 13.2182 14.6711 13.9269C15.3444 14.6711 16.3544 15.2027 17.701 15.5216C19.0476 15.8405 20.8549 16 23.1229 16V12.3322C21.4928 12.3322 20.4297 12.0842 19.9336 11.588C19.6855 11.34 19.5083 10.9856 19.402 10.5249C19.3311 10.0997 19.2957 9.53267 19.2957 8.82392V8.13289H23.1229V0H13.0233V6.16611Z" fill="#0D2A6F" fill-opacity="0.6" />
        </svg>
        <p>
          This site uses functional and performance cookies to provide customer support features, analyze traffic,
          and help us provide you with the best experience we can. By clicking “Accept All”, you agree Codepresso
          can store cookies on your device and disclose information in accordance with our
          <NuxtLink to="/policy?tab=3">Cookie Policy</NuxtLink>
        </p>
        <div class="btnArea flex">
          <button type="button"
                  class="btn toggleBtn"
                  :class="{ on: isShowCookiePreference }"
                  @click.stop="toggleCookiePreference">
            <span class="icon toggle">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
                <path
                    d="M0.96967 1.78033C0.676777 1.48744 0.676777 1.01256 0.96967 0.71967C1.26256 0.426777 1.73744 0.426777 2.03033 0.71967L0.96967 1.78033ZM5 4.75L5.53033 5.28033L5 5.81066L4.46967 5.28033L5 4.75ZM7.96967 0.71967C8.26256 0.426777 8.73744 0.426777 9.03033 0.71967C9.32322 1.01256 9.32322 1.48744 9.03033 1.78033L7.96967 0.71967ZM2.03033 0.71967L5.53033 4.21967L4.46967 5.28033L0.96967 1.78033L2.03033 0.71967ZM4.46967 4.21967L7.96967 0.71967L9.03033 1.78033L5.53033 5.28033L4.46967 4.21967Z"
                    fill="#8697BF" fill-opacity="0.65" />
              </svg>
            </span>Cookie Preferences
          </button>
          <button v-if="isShowCookiePreference" class="btn primaryBtn" @click.stop="saveCookies">
            Save
          </button>
          <button v-else class="btn primaryBtn" @click.stop="acceptCookies">
            Accept All
          </button>
        </div>
      </div>
      <LazyCookieManage :class="{ on: isShowCookiePreference }" @change-agreements="updateAgreements" />
    </section>
  </div>
</template>

<script setup lang="ts">
import {ref, onMounted} from 'vue';
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useUtilsStore} from '~/store/utils/utilsStore';
import {setPolicyCookies} from '~~/package/utils/CookieUtil';
import {useThirdPartyRegistrationService} from '~/composables/service/useThirdPartyRegistrationService';

const dialogStore = useDialogStore();
const utilsStore = useUtilsStore();
const thirdPartyRegistrationService = useThirdPartyRegistrationService();

const isShowCookiePreference = ref(false);

const agreements = ref({
  necessary: true,
  functional: true,
  performance: true
});

const toggleCookiePreference = () => {
  isShowCookiePreference.value = !isShowCookiePreference.value;
};

onMounted(() => {
  const isFromPolicyPage = dialogStore.options.props.isShowCookiePreference;
  if (isFromPolicyPage) {
    isShowCookiePreference.value = isFromPolicyPage;
  }
});

const updateAgreements = (changedAgreements: {necessary: boolean; functional: boolean; performance: boolean}) => {
  agreements.value.functional = changedAgreements.functional;
  agreements.value.performance = changedAgreements.performance;
};

const saveCookies = () => {
  setPolicyCookies(agreements.value);
  // performance를 켜고 저장해도 리로드 전까지 서드파티가 초기화되지 않던 기존 갭 수정
  thirdPartyRegistrationService.registration();
  utilsStore.functionalConsent = agreements.value.functional;
  dialogStore.close();
};

const acceptCookies = () => {
  setPolicyCookies({necessary: true, performance: true, functional: true});
  thirdPartyRegistrationService.registration();
  utilsStore.functionalConsent = true;
  dialogStore.close();
};
</script>
